export const mypethooliganNFTs = [

  {
    id: 'my-pet-hooligan-8731',
    name: 'Hooligan #8731',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8731.png',
    price: '0.85 ETH'
  },
  {
    id: 'my-pet-hooligan-8730',
    name: 'Hooligan #8730',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8730.png',
    price: '0.42 ETH'
  },
  {
    id: 'my-pet-hooligan-8729',
    name: 'Hooligan #8729',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8729.png',
    price: '1.15 ETH'
  },
  {
    id: 'my-pet-hooligan-8728',
    name: 'Hooligan #8728',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8728.png',
    price: '0.67 ETH'
  },
  {
    id: 'my-pet-hooligan-8727',
    name: 'Hooligan #8727',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8727.png',
    price: '0.95 ETH'
  },
  {
    id: 'my-pet-hooligan-8726',
    name: 'Hooligan #8726',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8726.png',
    price: '0.33 ETH'
  },
  {
    id: 'my-pet-hooligan-8725',
    name: 'Hooligan #8725',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8725.png',
    price: '1.08 ETH'
  },
  {
    id: 'my-pet-hooligan-8724',
    name: 'Hooligan #8724',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8724.png',
    price: '0.56 ETH'
  },
  {
    id: 'my-pet-hooligan-8723',
    name: 'Hooligan #8723',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8723.png',
    price: '0.78 ETH'
  },
  {
    id: 'my-pet-hooligan-8722',
    name: 'Hooligan #8722',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8722.png',
    price: '0.24 ETH'
  },

  {
    id: 'my-pet-hooligan-8721',
    name: 'Hooligan #8721',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8721.png',
    price: '1.23 ETH'
  },
  {
    id: 'my-pet-hooligan-8720',
    name: 'Hooligan #8720', 
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8720.png',
    price: '0.45 ETH'
  },
  {
    id: 'my-pet-hooligan-8719',
    name: 'Hooligan #8719',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8719.png',
    price: '0.92 ETH'
  },
  {
    id: 'my-pet-hooligan-8718',
    name: 'Hooligan #8718',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8718.png',
    price: '0.63 ETH'
  },
  {
    id: 'my-pet-hooligan-8717',
    name: 'Hooligan #8717',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8717.png',
    price: '0.88 ETH'
  },
  {
    id: 'my-pet-hooligan-8716',
    name: 'Hooligan #8716',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8716.png',
    price: '0.37 ETH'
  },
  {
    id: 'my-pet-hooligan-8715',
    name: 'Hooligan #8715',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8715.png',
    price: '1.18 ETH'
  },
  {
    id: 'my-pet-hooligan-8714',
    name: 'Hooligan #8714',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8714.png',
    price: '0.52 ETH'
  },
  {
    id: 'my-pet-hooligan-8713',
    name: 'Hooligan #8713',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8713.png',
    price: '0.75 ETH'
  },
  {
    id: 'my-pet-hooligan-8712',
    name: 'Hooligan #8712',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8712.png',
    price: '0.29 ETH'
  },
  {
    id: 'my-pet-hooligan-8711',
    name: 'Hooligan #8711',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8711.png',
    price: '1.05 ETH'
  },
  {
    id: 'my-pet-hooligan-8710',
    name: 'Hooligan #8710',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8710.png',
    price: '0.48 ETH'
  },
  {
    id: 'my-pet-hooligan-8709',
    name: 'Hooligan #8709',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8709.png',
    price: '0.98 ETH'
  },
  {
    id: 'my-pet-hooligan-8708',
    name: 'Hooligan #8708',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8708.png',
    price: '0.59 ETH'
  },
  {
    id: 'my-pet-hooligan-8707',
    name: 'Hooligan #8707',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8707.png',
    price: '0.82 ETH'
  },
  {
    id: 'my-pet-hooligan-8706',
    name: 'Hooligan #8706',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8706.png',
    price: '0.35 ETH'
  },
  {
    id: 'my-pet-hooligan-8705',
    name: 'Hooligan #8705',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8705.png',
    price: '1.12 ETH'
  },
  {
    id: 'my-pet-hooligan-8704',
    name: 'Hooligan #8704',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8704.png',
    price: '0.54 ETH'
  },
  {
    id: 'my-pet-hooligan-8703',
    name: 'Hooligan #8703',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8703.png',
    price: '0.72 ETH'
  },
  {
    id: 'my-pet-hooligan-8702',
    name: 'Hooligan #8702',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8702.png',
    price: '0.27 ETH'
  },
  {
    id: 'my-pet-hooligan-8701',
    name: 'Hooligan #8701',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8701.png',
    price: '1.20 ETH'
  },
  {
    id: 'my-pet-hooligan-8700',
    name: 'Hooligan #8700',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8700.png',
    price: '0.44 ETH'
  },
  {
    id: 'my-pet-hooligan-8669',
    name: 'Hooligan #8669',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8669.png',
    price: '0.89 ETH'
  },
  {
    id: 'my-pet-hooligan-8699',
    name: 'Hooligan #8699',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8699.png',
    price: '0.65 ETH'
  },
  {
    id: 'my-pet-hooligan-8668',
    name: 'Hooligan #8668',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8668.png',
    price: '0.94 ETH'
  },
  {
    id: 'my-pet-hooligan-8698',
    name: 'Hooligan #8698',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8698.png',
    price: '0.31 ETH'
  },
  {
    id: 'my-pet-hooligan-8624',
    name: 'Hooligan #8624',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8624.png',
    price: '1.02 ETH'
  },
  {
    id: 'my-pet-hooligan-8667',
    name: 'Hooligan #8667',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8667.png',
    price: '0.51 ETH'
  },
  {
    id: 'my-pet-hooligan-8697',
    name: 'Hooligan #8697',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8697.png',
    price: '0.76 ETH'
  },
  {
    id: 'my-pet-hooligan-8623',
    name: 'Hooligan #8623',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8623.png',
    price: '0.25 ETH'
  },
  {
    id: 'my-pet-hooligan-8666',
    name: 'Hooligan #8666',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8666.png',
    price: '1.17 ETH'
  },
  {
    id: 'my-pet-hooligan-8696',
    name: 'Hooligan #8696',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8696.png',
    price: '0.47 ETH'
  },
  {
    id: 'my-pet-hooligan-8622',
    name: 'Hooligan #8622',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8622.png',
    price: '0.86 ETH'
  },
  {
    id: 'my-pet-hooligan-8665',
    name: 'Hooligan #8665',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8665.png',
    price: '0.61 ETH'
  },
  {
    id: 'my-pet-hooligan-8695',
    name: 'Hooligan #8695',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8695.png',
    price: '0.91 ETH'
  },
  {
    id: 'my-pet-hooligan-8664',
    name: 'Hooligan #8664',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8664.png',
    price: '0.34 ETH'
  },
  {
    id: 'my-pet-hooligan-8621',
    name: 'Hooligan #8621',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8621.png',
    price: '1.10 ETH'
  },
  {
    id: 'my-pet-hooligan-8694',
    name: 'Hooligan #8694',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8694.png',
    price: '0.55 ETH'
  },
  {
    id: 'my-pet-hooligan-8881',
    name: 'Hooligan #8881',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8881.png',
    price: '0.69 ETH'
  },
  {
    id: 'my-pet-hooligan-8841',
    name: 'Hooligan #8841',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8841.png',
    price: '0.28 ETH'
  },
  {
    id: 'my-pet-hooligan-8663',
    name: 'Hooligan #8663',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8663.png',
    price: '0.97 ETH'
  },
  {
    id: 'my-pet-hooligan-8620',
    name: 'Hooligan #8620',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8620.png',
    price: '0.43 ETH'
  },
  {
    id: 'my-pet-hooligan-8856',
    name: 'Hooligan #8856',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8856.png',
    price: '0.83 ETH'
  },
  {
    id: 'my-pet-hooligan-8693',
    name: 'Hooligan #8693',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8693.png',
    price: '0.36 ETH'
  },
  {
    id: 'my-pet-hooligan-8866',
    name: 'Hooligan #8866',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8866.png',
    price: '1.21 ETH'
  },
  {
    id: 'my-pet-hooligan-8806',
    name: 'Hooligan #8806',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8806.png',
    price: '0.58 ETH'
  },
  {
    id: 'my-pet-hooligan-8831',
    name: 'Hooligan #8831',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8831.png',
    price: '0.79 ETH'
  },

  {
    id: 'my-pet-hooligan-8871',
    name: 'Hooligan #8871',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8871.png',
    price: '0.87 ETH'
  },
  {
    id: 'my-pet-hooligan-8826',
    name: 'Hooligan #8826',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8826.png',
    price: '0.39 ETH'
  },
  {
    id: 'my-pet-hooligan-8766',
    name: 'Hooligan #8766',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8766.png',
    price: '1.13 ETH'
  },
  {
    id: 'my-pet-hooligan-8851',
    name: 'Hooligan #8851',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8851.png',
    price: '0.53 ETH'
  },
  {
    id: 'my-pet-hooligan-8816',
    name: 'Hooligan #8816',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8816.png',
    price: '0.74 ETH'
  },
  {
    id: 'my-pet-hooligan-8811',
    name: 'Hooligan #8811',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8811.png',
    price: '0.26 ETH'
  },
  {
    id: 'my-pet-hooligan-8876',
    name: 'Hooligan #8876',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8876.png',
    price: '1.19 ETH'
  },
  {
    id: 'my-pet-hooligan-8880',
    name: 'Hooligan #8880',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8880.png',
    price: '0.46 ETH'
  },
  {
    id: 'my-pet-hooligan-8776',
    name: 'Hooligan #8776',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8776.png',
    price: '0.93 ETH'
  },
  {
    id: 'my-pet-hooligan-8861',
    name: 'Hooligan #8861',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8861.png',
    price: '0.32 ETH'
  },
  {
    id: 'my-pet-hooligan-8886',
    name: 'Hooligan #8886',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8886.png',
    price: '1.03 ETH'
  },
  {
    id: 'my-pet-hooligan-8791',
    name: 'Hooligan #8791',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8791.png',
    price: '0.49 ETH'
  },
  {
    id: 'my-pet-hooligan-8771',
    name: 'Hooligan #8771',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8771.png',
    price: '0.77 ETH'
  },
  {
    id: 'my-pet-hooligan-8846',
    name: 'Hooligan #8846',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8846.png',
    price: '0.30 ETH'
  },
  {
    id: 'my-pet-hooligan-8840',
    name: 'Hooligan #8840',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8840.png',
    price: '1.16 ETH'
  },
  {
    id: 'my-pet-hooligan-8821',
    name: 'Hooligan #8821',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8821.png',
    price: '0.57 ETH'
  },
  {
    id: 'my-pet-hooligan-8662',
    name: 'Hooligan #8662',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8662.png',
    price: '0.84 ETH'
  },
  {
    id: 'my-pet-hooligan-8761',
    name: 'Hooligan #8761',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8761.png',
    price: '0.38 ETH'
  },
  {
    id: 'my-pet-hooligan-8619',
    name: 'Hooligan #8619',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8619.png',
    price: '1.11 ETH'
  },
  {
    id: 'my-pet-hooligan-8692',
    name: 'Hooligan #8692',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8692.png',
    price: '0.50 ETH'
  },
  {
    id: 'my-pet-hooligan-8855',
    name: 'Hooligan #8855',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8855.png',
    price: '0.71 ETH'
  },
  {
    id: 'my-pet-hooligan-8781',
    name: 'Hooligan #8781',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8781.png',
    price: '0.25 ETH'
  },
  {
    id: 'my-pet-hooligan-8786',
    name: 'Hooligan #8786',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8786.png',
    price: '1.22 ETH'
  },
  {
    id: 'my-pet-hooligan-8836',
    name: 'Hooligan #8836',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8836.png',
    price: '0.44 ETH'
  },
  {
    id: 'my-pet-hooligan-8865',
    name: 'Hooligan #8865',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8865.png',
    price: '0.96 ETH'
  },
  {
    id: 'my-pet-hooligan-8805',
    name: 'Hooligan #8805',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8805.png',
    price: '0.33 ETH'
  },
  {
    id: 'my-pet-hooligan-8746',
    name: 'Hooligan #8746',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8746.png',
    price: '1.07 ETH'
  },
  {
    id: 'my-pet-hooligan-8796',
    name: 'Hooligan #8796',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8796.png',
    price: '0.52 ETH'
  },
  {
    id: 'my-pet-hooligan-8756',
    name: 'Hooligan #8756',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8756.png',
    price: '0.81 ETH'
  },
  {
    id: 'my-pet-hooligan-8830',
    name: 'Hooligan #8830',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8830.png',
    price: '0.36 ETH'
  },
  {
    id: 'my-pet-hooligan-8801',
    name: 'Hooligan #8801',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8801.png',
    price: '1.14 ETH'
  },
  {
    id: 'my-pet-hooligan-8736',
    name: 'Hooligan #8736',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8736.png',
    price: '0.47 ETH'
  },
  {
    id: 'my-pet-hooligan-8741',
    name: 'Hooligan #8741',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8741.png',
    price: '0.90 ETH'
  },
  {
    id: 'my-pet-hooligan-8765',
    name: 'Hooligan #8765',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8765.png',
    price: '0.29 ETH'
  },
  {
    id: 'my-pet-hooligan-8850',
    name: 'Hooligan #8850',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8850.png',
    price: '1.04 ETH'
  },
  {
    id: 'my-pet-hooligan-8751',
    name: 'Hooligan #8751',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8751.png',
    price: '0.55 ETH'
  },
  {
    id: 'my-pet-hooligan-8875',
    name: 'Hooligan #8875',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8875.png',
    price: '0.68 ETH'
  },
  {
    id: 'my-pet-hooligan-8815',
    name: 'Hooligan #8815',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8815.png',
    price: '0.24 ETH'
  },
  {
    id: 'my-pet-hooligan-8810',
    name: 'Hooligan #8810',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8810.png',
    price: '1.20 ETH'
  },
  {
    id: 'my-pet-hooligan-8885',
    name: 'Hooligan #8885',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8885.png',
    price: '0.43 ETH'
  },
  {
    id: 'my-pet-hooligan-8825',
    name: 'Hooligan #8825',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8825.png',
    price: '0.99 ETH'
  },
  {
    id: 'my-pet-hooligan-8860',
    name: 'Hooligan #8860',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8860.png',
    price: '0.35 ETH'
  },
  {
    id: 'my-pet-hooligan-8775',
    name: 'Hooligan #8775',
    image: 'https://ipfs.io/ipfs/QmZqqLdyuQPvG9P3cr3AccSGJ1ivp5SRx3Ni7JmXr7CZE4/8775.png',
    price: '1.09 ETH'
  }



];